import React from 'react';
import {
  branch,
  compose,
  lifecycle,
  renderComponent,
  withStateHandlers,
} from 'recompose';
import { serviceLocator } from '../../infrastructure/ServiceLocator';
import LayoutHelper from '../../infrastructure/LayoutHelper';

interface Room {
  _id: string;
  name?: string;
  [key: string]: any;
}

interface RepeatableEvent {
  _id: string;
  [key: string]: any;
}

interface GroupCourse {
  _id: string;
  [key: string]: any;
}

interface Schedule {
  rooms: Room[];
  repeatableEvents: RepeatableEvent[];
  roomsMap: Record<string, Room>;
  groupCourses: GroupCourse[];
  repeatableEventsMap: Record<string, RepeatableEvent>;
  [key: string]: any;
}

interface Studio {
  id: string;
  [key: string]: any;
}

interface WithPublicScheduleProps {
  setSchedule: (props: PublicScheduleState) => void;
  studio: Studio;
  schedule?: Schedule;
  rooms: Room[];
  roomsMap: Record<string, Room>;
  repeatableEvents: RepeatableEvent[];
  repeatableEventsMap: Record<string, RepeatableEvent>;
  groupCourses?: GroupCourse[];
}

interface PublicScheduleState {
  schedule?: Schedule;
  rooms: Room[];
  roomsMap: Record<string, Room>;
  repeatableEvents: RepeatableEvent[];
  repeatableEventsMap: Record<string, RepeatableEvent>;
  groupCourses?: GroupCourse[];
}

export const withPublicSchedule = compose<React.ComponentType<WithPublicScheduleProps>, any>(
  withStateHandlers<PublicScheduleState, {
    setSchedule: (state: PublicScheduleState) => (props: PublicScheduleState) => PublicScheduleState;
  }>(
    {
      repeatableEvents: [],
      rooms: [],
      roomsMap: {},
      repeatableEventsMap: {},
    },
    {
      setSchedule: () => (props: PublicScheduleState) => ({ ...props }),
    }
  ),
  lifecycle<WithPublicScheduleProps, {}>({
    componentWillMount() {
      const { setSchedule, studio } = this.props;
      const api = serviceLocator.studioApi;
      api.getPublicSchedule(studio.id).then((response: Schedule) => {
        const schedule = response;
        const { rooms, repeatableEvents, roomsMap, groupCourses, repeatableEventsMap } = schedule;
        setSchedule({
          schedule,
          rooms,
          repeatableEvents,
          roomsMap,
          groupCourses,
          repeatableEventsMap,
        });
      }, LayoutHelper.onErr);
    },
  }),
  branch<WithPublicScheduleProps>(
    ({ schedule }) => !schedule,
    renderComponent(() => LayoutHelper.renderLoader())
  )
);